import { Container, Typography, Grid, Paper, Box, Avatar } from "@mui/material";
import { SearchRounded } from "@mui/icons-material";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { Form, Input, Submit } from "../Form";
import Items from "./Items";
import { search, clearResult } from '../../features/search/searchSlice'

const Search = () => {
    const { status } = useSelector(state => state.search)
    const dispatch = useDispatch();
    const methods = useForm();
    const onSubmit = data => dispatch(search({ id: data.code, setError: methods.setError }))
    return(
        <Container component={Paper} maxWidth={ status === 'idle' ? 'xs' : 'xl' } sx={{ p: '2em' }}>
            { status === 'idle' ? (
                <>
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }} >
                        <Avatar sx={{ bgcolor: 'success.main' }}> <SearchRounded /> </Avatar>
                        <Typography variant="h5" align="center">Consulta tus eventos!</Typography>
                        <Typography variant="caption">Solo debes escribir tu c&oacute;digo</Typography>
                    </Box>
                    <Form methods={methods} onSubmit={onSubmit}>
                        <Grid container spacing={2}>
                            <Input name='code' label={'Código'} min={7} max={9} regEx={/\w/ig} />
                            <Submit title="Buscar" />
                        </Grid>
                    </Form>
                </>)
            : <Items clearResult={clearResult} /> }
        </Container>
    )
}

export default Search;